import { render } from "./PaymentTypes.vue?vue&type=template&id=9f52f134"
import script from "./PaymentTypes.vue?vue&type=script&lang=js"
export * from "./PaymentTypes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Select/PaymentTypes.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9f52f134"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9f52f134', __exports__)) {
    api.reload('9f52f134', __exports__)
  }
  
  module.hot.accept("./PaymentTypes.vue?vue&type=template&id=9f52f134", () => {
    api.rerender('9f52f134', render)
  })

}


export default __exports__